import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Tabs from 'components/common/Tabs'
import MarketingContent from '../../TireDetailsPage/components/MarketingContent'

const BOTTireSizeLineDetailCartridge = ({
  placeholders: { tireLineSizeInformation = []} = {},
  productLineId,
  productId,
  tabsConfig,
  tabToActivate,
  eventName,
  ...props
}) => <Wrapper>
  <TireSizeTabs menu={ tabsConfig } eventName={ eventName } tabToActivate={ tabToActivate }>
    {
      React.Children.map(tireLineSizeInformation, content =>
        React.cloneElement(content, { ...props, productId })
      )
    }
  </TireSizeTabs>
  <MarketingContent
    margin_desktop="70px 0 0"
    margin_mobile="40px 0 0"
    type="line"
    id={ productLineId } />
</Wrapper>

BOTTireSizeLineDetailCartridge.propTypes = {
  eventName: PropTypes.string,
  name: PropTypes.string,
  placeholders: PropTypes.shape({
    tireLineSizeInformation: PropTypes.arrayOf()
  }),
  productId: PropTypes.string,
  productLineId: PropTypes.string,
  tabsConfig: PropTypes.arrayOf(PropTypes.shape()),
  tabToActivate: PropTypes.number
}

export default BOTTireSizeLineDetailCartridge

const Wrapper = styled.div`
  margin: 0 auto;
  margin-bottom: 100px;
  ${Media.mobile`
    padding: 0 16px;
  `}
`

const TireSizeTabs = styled(Tabs)`
  ${Mixin.responsive('margin', '0', '0 -15px')}
  ${Mixin.responsive('padding-left', '50px', '16px')}
`
